import { render, staticRenderFns } from "./PositionManagement.vue?vue&type=template&id=36e6f24a&scoped=true"
import script from "./PositionManagement.vue?vue&type=script&lang=js"
export * from "./PositionManagement.vue?vue&type=script&lang=js"
import style0 from "./PositionManagement.vue?vue&type=style&index=0&id=36e6f24a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e6f24a",
  null
  
)

export default component.exports